import { createSelector } from "@ngrx/store";
import { AppStore } from "src/app/store";

export const selectAlertState = (state:AppStore) => state.alerts;

export const getAlerts = createSelector(
    selectAlertState,
    (state) => state.alerts
);